import type {ReactElement} from 'react';
import {Text, TextSize} from '@Components/text';
import {Dropdown} from '@Components/dropdown-v2';
import type {EventDropdownProps} from './event-dropdown.types';
import styles from './event-dropdown.module.scss';

export function EventDropdown({text, popupClass, ...dropdownProps}: EventDropdownProps): ReactElement<any> {
  return (
    <>
      {text ? <Text className={styles.textNoWrap} val={text} size={TextSize.XXSMALL} bold /> : undefined}
      <Dropdown
        doCloseOnInnerClick={false}
        popupSpacingClass="spacing-p-t-3 spacing-p-l-3 spacing-p-r-3 spacing-p-b-1"
        popupClassName={`${popupClass} border-s-standard radius-8`}
        modalClassName={`${styles.mobileModal} spacing-p-4`}
        {...dropdownProps}
      />
    </>
  );
}
